import { Component } from '@angular/core';
import { HOME_CONTENT_MOCK } from '../../data/home-content.mock';
import { AnalyticsTagService } from '../../../../services/analytics-tag.service';

export interface HomeHeaderNavItem {
  label: string;
  anchorId: string;
  elementId: string;
}

@Component({
  selector: 'app-home-header',
  templateUrl: './home-header.component.html',
  styleUrls: ['./home-header.component.scss'],
  standalone: false,
})
export class HomeHeaderComponent {
  readonly content = HOME_CONTENT_MOCK.header;
  readonly anchors = HOME_CONTENT_MOCK.anchors;

  readonly navItems: HomeHeaderNavItem[] = [
    {
      label: this.content.nav.comoFunciona,
      anchorId: this.anchors.comoFunciona,
      elementId: 'btn-home-nav-como-funciona',
    },
    {
      label: this.content.nav.aliados,
      anchorId: this.anchors.aliados,
      elementId: 'btn-home-nav-aliados',
    },
    {
      label: this.content.nav.creaTuCuenta,
      anchorId: this.anchors.creaCuenta,
      elementId: 'btn-home-nav-crea-cuenta',
    },
  ];

  constructor(private readonly analyticsTag: AnalyticsTagService) {}

  scrollToSection(item: HomeHeaderNavItem, event?: Event): void {
    event?.preventDefault();

    this.analyticsTag.trackCtaClick({
      ctaLabel: item.label,
      ctaSection: 'header',
      ctaComponent: 'home-header',
      ctaElementId: item.elementId,
      hu: '8300',
    });

    const target = document.getElementById(item.anchorId);
    if (!target) {
      return;
    }

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  trackIniciarSesion(): void {
    this.analyticsTag.trackCtaClick({
      ctaLabel: this.content.iniciarSesion,
      ctaSection: 'header',
      ctaComponent: 'home-header',
      ctaElementId: 'btn-home-iniciar-sesion',
      hu: '8300',
    });
  }
}
